import AddStudentExamModal from './AddStudentExamModal';

export default AddStudentExamModal;
